<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import TableControl from '../elements/TableControl.svelte';
  import { getFormContext } from '../forms/FormProviderCore.svelte';

  const { values, setFieldValue } = getFormContext();

  $: allUsers = $values.allUsers;
  $: usedUsers = $values.usedUsers;
</script>

<TableControl
  stickyHeader
  checkedKeys={usedUsers}
  onSetCheckedKeys={keys => setFieldValue('usedUsers', keys)}
  columns={[
    { header: 'Login', fieldName: 'login', sortable: true, filterable: true },
    { header: 'E-mail', fieldName: 'email', sortable: true, filterable: true },
  ]}
  rows={allUsers}
/>
